import React, { useEffect, useState, useRef } from 'react'

import Drawer from '@material-ui/core/Drawer'

import usePostData from 'hooks/post-data'
import useFetchData from 'hooks/fetch-data'

import { FormTitle } from 'components/Maintainance/components'
import { CustomDropDownWithPagination, MinimalInput, MinimalTextArea } from 'components/Assets/components'
import { MinimalButtonGroup, MinimalButton } from 'components/common/buttons'
import { MinimalAutoComplete } from 'components/Assets/components'
import { AssetImage, AssetImageUploadButton } from 'components/WorkOrders/onboarding/utils'

import { statusOptions, allowAddAsset, filterNumberValue } from './utils'

import facilities from 'Services/facilities/index'
import getProjectManagerList from 'Services/User/getProjectManagerList'

import * as yup from 'yup'
import { validateSchema } from 'helpers/schemaValidation'

import { get, isEmpty } from 'lodash'
import { Toast } from 'Snackbar/useToast'
import ImagePreview from 'components/common/image-preview'

const AddSites = ({ open, onClose, isEdit, reFetch, clientCompanyId, anchorObj, stateData, clientCompanies }) => {
  const [siteData, setSiteData] = useState({
    siteName: '',
    siteCode: '',
    status: statusOptions[0].value,
    isAddAssetClassEnabled: allowAddAsset[0].value,
    customer: '',
    customerAddress: '',
    customerAddress2: '',
    city: '',
    zip: '',
    stateId: null,
    clientCompanyId: null,
    sitecontactId: null,
    siteProjectmanagerList: [],
    profileImage: null,
  })
  const [newManagerItem, setNewManagerItem] = useState([])
  const [error, setError] = useState('')
  const [isPhotoUploading, setPhotoUploading] = useState(false)
  const [isPreviewOpen, setPreview] = useState(false)
  const [randomValue, setRandomValue] = useState(0)
  const [companyList, setCompanyList] = useState([])
  const [searchString, setSearchString] = useState('')
  const [loading, setLoading] = useState(false)
  const [pageSize, setPageSize] = useState(20)

  const uploadPhotosRef = useRef(null)
  const scrollableContainerRef = useRef(null)
  const previousScrollTop = useRef(0)

  const handleInputChange = (name, value) => {
    setSiteData({ ...siteData, [name]: value })
  }

  const handleManagerFormatter = data => {
    const options = data.map(v => ({ ...v, label: `${v.firstname} ${v.lastname} - ${v.email}`, value: v.uuid }))
    return options
  }

  const { loading: projectMamagerLoading, data: managerOptions } = useFetchData({ fetch: getProjectManagerList, formatter: d => handleManagerFormatter(get(d, 'list', [])) })

  const compareManagerArray = (arr1, arr2) => {
    const userMap = new Set(arr1.map(item => item.userId))

    const removedItemsArray = arr2.filter(item => !userMap.has(item.userId)).map(removedItem => ({ ...removedItem, isDeleted: true }))

    const newItemsArray = newManagerItem.map(newItem => ({
      ...newItem,
      isDeleted: false,
      siteProjectmanagerMappingId: null,
      userId: newItem.value,
    }))

    return [...removedItemsArray, ...newItemsArray]
  }

  const validateForm = async () => {
    const schema = yup.object().shape({
      siteName: yup.string().required('Facilities Name is required !'),
      siteCode: yup.string().required('Facilities Code is required !'),
      customer: yup.string().required('Customer Name is required !'),
      customerAddress: yup.string().required('Customer Address is required !'),
      clientCompanyId: yup.string().required('Client Company is required !'),
      zip: yup.string().max(6, 'Please enter a valid ZIP code !').nullable(),
    })
    const playload = { ...siteData, clientCompanyId: get(siteData, 'clientCompanyId.value', '') }
    const isValid = await validateSchema(playload, schema)
    setError(isValid)
    if (isValid === true) submitData(playload)
  }

  const postSuccess = () => {
    onClose()
    reFetch()
    // setAfterFilterSite(true)
  }

  const wpPayload = { pageSize: pageSize, pageIndex: 1, search_string: isEmpty(searchString) ? '' : searchString, client_company_id: get(siteData, 'clientCompanyId.value', null) }
  const { loading: contactLoading, data: contactData, reFetch: getContactList } = useFetchData({ fetch: facilities.getAllSiteContacts, payload: wpPayload, formatter: d => get(d, 'data', []), condition: !loading && !isEmpty(get(siteData, 'clientCompanyId.value', '')) })

  const { loading: isLoading, mutate: sites } = usePostData({ executer: facilities.site.create, postSuccess, message: { success: !isEdit ? 'Facility Create Successfully!' : 'Facility Update successfully!', error: 'Something went wrong' } })
  const submitData = async payload => {
    const newManagerValue = compareManagerArray(siteData.siteProjectmanagerList, get(anchorObj, 'siteProjectmanagerList', []))

    const obj = {
      ...payload,
      status: siteData.status,
      isAddAssetClassEnabled: !!parseInt(siteData.isAddAssetClassEnabled),
      companyId: localStorage.getItem('defaultCompanyId'),
      stateId: get(siteData, 'stateId.stateId', null),
      sitecontactId: get(siteData, 'sitecontactId.sitecontactId', null),
    }
    if (isEdit) {
      sites({ ...obj, siteId: get(anchorObj, 'siteId', ''), siteProjectmanagerList: newManagerValue ? newManagerValue.map(d => ({ userId: d.userId, isDeleted: d.isDeleted, siteProjectmanagerMappingId: d.siteProjectmanagerMappingId })) : [] })
    } else {
      sites({ ...obj, siteProjectmanagerList: siteData.siteProjectmanagerList ? siteData.siteProjectmanagerList.map(d => ({ userId: d.value, isDeleted: false, siteProjectmanagerMappingId: null })) : [] })
    }
  }

  useEffect(() => {
    if (isEdit) {
      let clientCompany = clientCompanyId && !isEmpty(companyList) ? companyList.find(d => d.value == clientCompanyId) || null : null
      let stateIdValue = get(anchorObj, 'stateId', null)
      let stateId = stateIdValue && !isEmpty(stateData) ? stateData.find(d => d.value === stateIdValue) || null : null

      setSiteData({
        siteName: get(anchorObj, 'siteName', ''),
        siteCode: get(anchorObj, 'siteCode', ''),
        status: get(anchorObj, 'status', 1),
        isAddAssetClassEnabled: anchorObj.isAddAssetClassEnabled === true ? '1' : '0',
        customer: get(anchorObj, 'customer', ''),
        customerAddress: get(anchorObj, 'customerAddress', ''),
        customerAddress2: get(anchorObj, 'customerAddress2', ''),
        stateId: stateId,
        clientCompanyId: clientCompany,
        sitecontactId: get(anchorObj, 'sitecontactData', null),
        city: get(anchorObj, 'city', null),
        zip: get(anchorObj, 'zip', null),
        siteProjectmanagerList: get(anchorObj, 'siteProjectmanagerList', []).map(d => ({ ...d, label: `${d.name} - ${d.email}`, value: d.userId, isDeleted: false })),
        profileImage: get(anchorObj, 'profileImage', null),
      })
    } else if (!get(siteData, 'clientCompanyId', null)) {
      let clientCompany = clientCompanyId && !isEmpty(companyList) ? companyList.find(d => d.value == clientCompanyId) || null : null
      setSiteData({ ...siteData, clientCompanyId: clientCompany })
    }
  }, [anchorObj, isEdit, companyList])

  useEffect(() => {
    let sortedList = []
    if (!isEmpty(clientCompanies)) {
      sortedList = clientCompanies.map(item => ({
        label: item.clientCompanyName,
        value: item.clientCompanyId,
      }))
    }
    setCompanyList(sortedList)
  }, [clientCompanies])

  useEffect(() => {
    if (!get(siteData, 'clientCompanyId', null)) {
      handleInputChange('sitecontactId', null)
    }
  }, [siteData.clientCompanyId])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (scrollableContainerRef.current) {
        scrollableContainerRef.current.scrollTop = previousScrollTop.current
      }
    }, 100)
    return () => clearTimeout(timer)
  }, [contactData])

  useEffect(() => {
    setLoading(true)
    let timer = setTimeout(() => {
      setLoading(false)
    }, 800)
    return () => clearTimeout(timer)
  }, [searchString])

  const handleManager = selectedManagers => {
    setSiteData(prevState => ({
      ...prevState,
      siteProjectmanagerList: selectedManagers,
    }))
    const newAddedItem = selectedManagers.filter(d => !siteData.siteProjectmanagerList.some(e => e.userId === d.value))
    setNewManagerItem(newAddedItem)
  }

  const handleUpload = () => {
    uploadPhotosRef.current && uploadPhotosRef.current.click()
  }
  // const addPhoto = async e => {
  //   e.preventDefault()
  //   setPhotoUploading(true)

  //   // Get the file from the event target
  //   const inputElement = e.target
  //   const file = inputElement.files[0]

  //   if (!file) return // No file selected

  //   const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'eps', 'heif', 'heic', 'JPEG', 'JPG', 'GIF', 'PNG', 'HEIF', 'HEIC']
  //   const extension = file.name.split('.').slice(-1).pop().toLowerCase()

  //   // Check if the file extension is valid
  //   if (!validExtensions.includes(extension)) {
  //     Toast.error('Invalid Image format!')
  //     return
  //   }

  //   // Convert HEIC/HEIF files to JPG using heic2any
  //   let processedFile = file
  //   if (['heic', 'heif'].includes(extension)) {
  //     try {
  //       const blob = await heic2any({
  //         blob: file,
  //         toType: 'image/jpeg',
  //       })

  //       processedFile = new File([blob], file.name.replace(/\.(heic|heif)$/i, '.jpg'), {
  //         type: 'image/jpeg',
  //       })
  //     } catch (error) {
  //       console.error('Error converting HEIC/HEIF to JPG:', error)
  //       Toast.error('Failed to process HEIC/HEIF format!')
  //       return
  //     }
  //   }

  //   // Proceed to upload the processed file
  //   const reader = new FileReader()
  //   reader.onload = () => {
  //     uploadPhoto(processedFile) // Upload the final file
  //   }
  //   reader.readAsDataURL(processedFile)

  //   // Reset the file input value
  //   if (inputElement && inputElement.value) {
  //     inputElement.value = null
  //   }
  // }

  const addPhoto = e => {
    e.preventDefault()
    if (!e.target.files[0]) return

    const reader = new FileReader()
    const file = e.target.files[0]
    reader.onload = d => {
      const extension = file.name.split('.').slice(-1).pop()
      if (!['jpg', 'jpeg', 'png', 'PNG', 'gif', 'eps', 'JPEG', 'JPG', 'GIF', 'HEIC', 'HEIF', 'heic', 'heif'].includes(extension)) Toast.error('Invalid Image format !')
      else uploadPhoto(file)
    }
    reader.onloadend = () => {}
    reader.readAsDataURL(file)
    e.target.value = null
  }

  const uploadPhoto = async file => {
    const fileData = new FormData()
    fileData.append('file', file)
    fileData.append('site_id', get(anchorObj, 'siteId', null))
    fileData.append('company_id', localStorage.getItem('companyId'))
    setPhotoUploading(true)
    try {
      const res = await facilities.site.uploadPhoto(fileData)
      if (res.success === 1) setSiteData({ ...siteData, profileImage: res.data.fileUrl })
      else Toast.error(res.message || 'Error uploading Image !')
    } catch (error) {
      Toast.error('Error uploading Image !')
    }
    setPhotoUploading(false)
  }

  const handleLoadMore = () => {
    if (scrollableContainerRef.current) {
      previousScrollTop.current = scrollableContainerRef.current.scrollTop
    }
    setPageSize(pageSize + 20)
  }

  return (
    <Drawer anchor='right' open={open} onClose={onClose}>
      <FormTitle title={!isEdit ? 'Add Facilities' : 'Edit Facilities'} style={{ width: '100%', minWidth: '500px' }} closeFunc={onClose} />
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ maxHeight: 'calc(100vh - 65px)', height: 'calc(100vh - 65px)', background: '#efefef', width: '500px' }}>
        <div style={{ padding: '10px' }}>
          <div style={{ padding: '16px', background: '#fff', borderRadius: '4px' }}>
            <MinimalAutoComplete placeholder='Select Client Company' value={get(siteData, 'clientCompanyId', '') || ''} onChange={value => handleInputChange('clientCompanyId', value)} options={companyList} label='Client Company' isClearable w={100} error={error.clientCompanyId} onFocus={() => setError({ ...error, clientCompanyId: null })} />
            <MinimalInput value={get(siteData, 'siteName', '') || ''} onChange={value => handleInputChange('siteName', value)} error={error.siteName} onFocus={() => setError({ ...error, siteName: null })} label='Facilities Name' placeholder='Enter Facilities Name' w={100} />
            <MinimalInput value={get(siteData, 'siteCode', '') || ''} onChange={value => handleInputChange('siteCode', value)} error={error.siteCode} onFocus={() => setError({ ...error, siteCode: null })} label='Facilities Code' placeholder='Enter Facilities Code' w={100} />
            <MinimalButtonGroup label='Status' value={get(siteData, 'status', '') || ''} onChange={value => handleInputChange('status', value)} options={statusOptions} w={100} />
            <div className='d-flex flex-row'>
              <MinimalButtonGroup label='Is Allowed to Add Asset Class?' value={get(siteData, 'isAddAssetClassEnabled', '') || ''} onChange={value => handleInputChange('isAddAssetClassEnabled', value)} options={allowAddAsset} w={100} />
              <MinimalAutoComplete placeholder='Select Managers' label='Project Managers' value={siteData.siteProjectmanagerList.filter(d => !d.isDeleted)} onChange={v => handleManager(v)} options={managerOptions} isClearable w={100} isMulti isLoading={projectMamagerLoading} baseStyles={{ marginRight: '0px' }} />
            </div>
            <MinimalInput value={get(siteData, 'customer', '') || ''} onChange={value => handleInputChange('customer', value)} error={error.customer} onFocus={() => setError({ ...error, customer: null })} label='Customer Name' placeholder='Enter Customer Name' w={100} />
            <MinimalInput value={get(siteData, 'customerAddress', '') || ''} onChange={value => handleInputChange('customerAddress', value)} label='Address Line 1' error={error.customerAddress} onFocus={() => setError({ ...error, customerAddress: null })} placeholder='Enter Address Line 1' w={100} />
            <MinimalInput value={get(siteData, 'customerAddress2', '') || ''} onChange={value => handleInputChange('customerAddress2', value)} label='Address Line 2' error={error.customerAddress2} onFocus={() => setError({ ...error, customerAddress2: null })} placeholder='Enter Address Line 2' w={100} />
            <MinimalInput value={get(siteData, 'city', '') || ''} onChange={value => handleInputChange('city', value)} label='City' error={error.city} onFocus={() => setError({ ...error, city: null })} placeholder='Enter City' w={100} />
            <div className='d-flex flex-row'>
              <MinimalAutoComplete placeholder='Enter State' value={get(siteData, 'stateId', null) || null} onChange={value => handleInputChange('stateId', value)} options={stateData} label='State' isClearable w={100} />
              <MinimalInput value={get(siteData, 'zip', '') || ''} onChange={value => handleInputChange('zip', filterNumberValue(value))} label='Zip' error={error.zip} onFocus={() => setError({ ...error, zip: null })} placeholder='Enter Zip' w={100} baseStyles={{ marginRight: '0px' }} />
            </div>
            {/* <MinimalTextArea
              rows={3}
              value={get(siteData, 'customerAddress', '') || ''}
              onChange={e => handleInputChange('customerAddress', e.target.value)}
              error={error.customerAddress}
              onFocus={() => setError({ ...error, customerAddress: null })}
              placeholder='Enter Customer Address'
              label='Customer Address'
              w={100}
              baseStyles={{ marginBottom: 0 }}
            /> */}
            <div style={{ marginTop: '4px' }}>
              <div className='d-flex justify-content-between'>
                <div className='text-bold'>Photo</div>
                <AssetImageUploadButton loading={isPhotoUploading} disabled={isPhotoUploading} onClick={handleUpload} />
              </div>
              <input ref={uploadPhotosRef} type='file' style={{ display: 'none' }} onChange={addPhoto} />
              {siteData.profileImage != null && (
                <div className='pt-3 mb-2 d-flex'>
                  <AssetImage onClick={() => setPreview(true)} onRemove={() => setSiteData(prev => ({ ...prev, profileImage: null }))} url={`${get(siteData, 'profileImage', null)}?value=${randomValue}`} randomValue={randomValue} />
                </div>
              )}
            </div>
          </div>
          <div style={{ padding: '16px', background: '#fff', borderRadius: '4px' }} className='mt-3'>
            <CustomDropDownWithPagination
              placeholder='Select Facility Contact'
              value={get(siteData, 'sitecontactId', null) ? { ...get(siteData, 'sitecontactId', {}), label: get(siteData, 'sitecontactId.sitecontactTitle', '') } : null}
              onChange={value => handleInputChange('sitecontactId', value)}
              onSearch={setSearchString}
              loadMore={handleLoadMore}
              options={get(contactData, 'list', [])}
              scrollableRef={scrollableContainerRef}
              label='Facility Contact'
              isClearable
              w={100}
              isLoading={contactLoading || loading}
              search={searchString}
              totalCount={get(contactData, 'listsize', 0)}
              error={error.sitecontactId}
              keyName='sitecontactTitle'
              onFocus={() => setError({ ...error, sitecontactId: null })}
              disabled={isEmpty(get(siteData, 'clientCompanyId.value', ''))}
            />
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-between align-items-center' style={{ borderTop: '1px solid #A6A6A6', borderBottom: 'none', background: '#fff', marginTop: 'auto', padding: '12px' }}>
        <MinimalButton variant='contained' color='default' text='Cancel' onClick={onClose} />
        <MinimalButton variant='contained' color='primary' text={!isEdit ? 'Add' : 'Update'} loadingText={!isEdit ? 'Adding...' : 'Updating...'} onClick={validateForm} disabled={isLoading} loading={isLoading} style={{ marginLeft: '10px' }} />
      </div>

      {isPreviewOpen && <ImagePreview open={isPreviewOpen} onClose={() => setPreview(false)} imageIndex={0} images={[{ imageFileNameUrl: siteData.profileImage }]} urlKey='imageFileNameUrl' reFetch={() => setRandomValue(Math.random())} />}
    </Drawer>
  )
}

export default AddSites
